import four from "./AboutImages/four.png";
import hilton from "./AboutImages/hilton.png";
import hyatt from "./AboutImages/hyatt.png";
import itc from "./AboutImages/itc.png";
import leela from "./AboutImages/leela.png";
import marriott from "./AboutImages/marriot.png";
import oberoi from "./AboutImages/oberoi.png";
import taj from "./AboutImages/taj.jpg";
import serai from "./AboutImages/serai.png";

const hotels = [
  {
    name: "Marriott International",
    logo: oberoi,
  },
  {
    name: "Hilton Hotels",
    logo: hilton,
  },
  {
    name: "Hyatt",
    logo: hyatt,
  },
  {
    name: "Taj Hotels",
    logo: taj,
  },

  {
    name: "ITC Hotels",
    logo: itc,
  },
  {
    name: "Four",
    logo: four,
  },
  {
    name: "serai",
    logo: serai,
  },
  {
    name: "leela",
    logo: leela,
  },
  {
    name: "marriot",
    logo: marriott,
  },
];

export default hotels;
